import { useQuery } from '@tanstack/react-query';
import { LogOut } from 'lucide-react';

import { userQueries } from '@/queries/user/user.queries';
import { getInitials } from '@/services/string';
import { useAuthStore } from '@/store';

import Notification from './features/notification';
import { AvatarProfile } from './features/profile/profile.index';
import { Avatar, AvatarFallback } from './ui/avatar';
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger
} from './ui/dropdown-menu';
import { WithStateQuery } from './ui/with-state';

export default function AppHeader() {
	const logout = useAuthStore((s) => s.logout);

	const user = useQuery(userQueries.user());

	return (
		<div className="flex items-center justify-between gap-2 px-6 py-4 shadow-lg">
			<img src="/logo/circle-logo.webp" alt="satu-indonesia" className="w-24" />
			<div className="flex items-center md:gap-4 lg:gap-6">
				<img
					src="/logo/satu-indonesia.webp"
					alt="satu-indonesia"
					className="w-16"
				/>
				<Notification />
				<WithStateQuery state={user}>
					{({ data: { email, name, profilePicture } }) => (
						<DropdownMenu>
							<DropdownMenuTrigger asChild>
								<Avatar className="h-8 w-8 rounded-full">
									{profilePicture ? <AvatarProfile fileKey={profilePicture} /> : null}
									<AvatarFallback className="rounded-full border border-gray-400">
										{getInitials(name)}
									</AvatarFallback>
								</Avatar>
							</DropdownMenuTrigger>
							<DropdownMenuContent
								className="w-(--radix-dropdown-menu-trigger-width) min-w-64 rounded-lg"
								side={'bottom'}
								align="end"
								sideOffset={4}
							>
								<DropdownMenuLabel className="p-0 font-normal">
									<div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
										<div className="grid flex-1 gap-1 text-left text-sm leading-tight">
											<span className="truncate font-medium">{name}</span>
											<span className="truncate text-xs">{email}</span>
										</div>
									</div>
								</DropdownMenuLabel>
								<DropdownMenuSeparator />
								<DropdownMenuItem className="font-bold" onClick={logout}>
									<LogOut className="text-black" />
									Log out
								</DropdownMenuItem>
							</DropdownMenuContent>
						</DropdownMenu>
					)}
				</WithStateQuery>
			</div>
		</div>
	);
}
